<template>
  <div
    class="offcanvas offcanvas-end"
    data-bs-scroll="true"
    tabindex="-1"
    id="mapOffcanvas"
  >
    <div class="offcanvas-header">
      <h5 class="offcanvas-title">Unit Details</h5>
      <button
        type="button"
        class="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <div
      class="offcanvas-body"
      v-if="this.$store.getters.accountPrivilege === 'admin'"
    >
      <section class="version-table mt-2 mb-2">
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">Name :</div>
          <div style="display: table-cell; text-align: left">
            {{ name }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">Type :</div>
          <div style="display: table-cell; text-align: left">
            {{ purpose }}
          </div>
        </header>
        <header v-show="purpose === 'sprinkler'" style="display: table-row">
          <div style="display: table-cell; text-align: right">radius (m) :</div>
          <div style="display: table-cell; text-align: left">
            {{ radius }}
          </div>
        </header>
        <header v-show="purpose === 'sprinkler'" style="display: table-row">
          <div style="display: table-cell; text-align: right">
            coverage (%) :
          </div>
          <div style="display: table-cell; text-align: left">
            {{ coverage }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">Stable :</div>
          <div style="display: table-cell; text-align: left">
            {{ stable }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">
            Hibernating :
          </div>
          <div style="display: table-cell; text-align: left">
            {{ hibernating }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">Battery :</div>
          <div style="display: table-cell; text-align: left">
            {{ battery }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">
            Firmware Done :
          </div>
          <div style="display: table-cell; text-align: left">
            {{ firmware_done }}
          </div>
        </header>
        <header v-show="purpose === 'sprinkler'" style="display: table-row">
          <div style="display: table-cell; text-align: right">
            Schedule Done :
          </div>
          <div style="display: table-cell; text-align: left">
            {{ schedule_done }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">Seen :</div>
          <div style="display: table-cell; text-align: left">
            {{ seen }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">
            Fault Charger :
          </div>
          <div style="display: table-cell; text-align: left">
            {{ fault_charger }}
          </div>
        </header>
        <header v-show="purpose === 'sprinkler'" style="display: table-row">
          <div style="display: table-cell; text-align: right">
            Fault Valve :
          </div>
          <div style="display: table-cell; text-align: left">
            {{ fault_valve }}
          </div>
        </header>
        <header v-show="purpose === 'sprinkler'" style="display: table-row">
          <div style="display: table-cell; text-align: right">Fault Dry :</div>
          <div style="display: table-cell; text-align: left">
            {{ fault_dry }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">Fault Awol :</div>
          <div style="display: table-cell; text-align: left">
            {{ fault_awol }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">ID :</div>
          <div style="display: table-cell; text-align: left">
            {{
              ("00000000" + parseInt(mac).toString(16).toUpperCase()).slice(-8)
            }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">latitude :</div>
          <div style="display: table-cell; text-align: left">
            {{ latitude }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">longitude :</div>
          <div style="display: table-cell; text-align: left">
            {{ longitude }}
          </div>
        </header>
      </section>
    </div>
    <div
      class="offcanvas-body"
      v-if="this.$store.getters.accountPrivilege !== 'admin'"
    >
      <section class="version-table mt-2 mb-2">
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">Name :</div>
          <div style="display: table-cell; text-align: left">
            {{ name }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">Type :</div>
          <div style="display: table-cell; text-align: left">
            {{ purpose }}
          </div>
        </header>
        <header v-show="purpose === 'sprinkler'" style="display: table-row">
          <div style="display: table-cell; text-align: right">radius (m) :</div>
          <div style="display: table-cell; text-align: left">
            {{ radius }}
          </div>
        </header>
        <header v-show="purpose === 'sprinkler'" style="display: table-row">
          <div style="display: table-cell; text-align: right">
            coverage (%) :
          </div>
          <div style="display: table-cell; text-align: left">
            {{ coverage }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">ID :</div>
          <div style="display: table-cell; text-align: left">
            {{
              ("00000000" + parseInt(mac).toString(16).toUpperCase()).slice(-8)
            }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">latitude :</div>
          <div style="display: table-cell; text-align: left">
            {{ latitude }}
          </div>
        </header>
        <header style="display: table-row">
          <div style="display: table-cell; text-align: right">longitude :</div>
          <div style="display: table-cell; text-align: left">
            {{ longitude }}
          </div>
        </header>
        <hr />
        <header
          v-show="purpose === 'sprinkler' && fault_valve > 0"
          style="display: table-row"
        >
          <div style="display: table-cell; text-align: right">Stuck on :</div>
          <div style="display: table-cell; text-align: left">
            {{ fault_valve }}
          </div>
        </header>
        <header
          v-show="purpose === 'sprinkler' && fault_dry > 0"
          style="display: table-row"
        >
          <div style="display: table-cell; text-align: right">Dry fault :</div>
          <div style="display: table-cell; text-align: left">
            {{ fault_dry }}
          </div>
        </header>
        <header v-show="fault_charger > 0" style="display: table-row">
          <div style="display: table-cell; text-align: right">
            Service required :
          </div>
          <div style="display: table-cell; text-align: left">
            {{ fault_charger }}
          </div>
        </header>
        <header v-show="battery === 'low'" style="display: table-row">
          <div style="display: table-cell; text-align: right">Battery :</div>
          <div style="display: table-cell; text-align: left">
            {{ battery }}
          </div>
        </header>
        <header v-show="fault_awol > 50" style="display: table-row">
          <div style="display: table-cell; text-align: right">Missing :</div>
          <div style="display: table-cell; text-align: left">
            {{ fault_awol }}
          </div>
        </header>
        <header v-show="hibernating" style="display: table-row">
          <div style="display: table-cell; text-align: right">
            Low-power mode :
          </div>
          <div style="display: table-cell; text-align: left">
            {{ hibernating }}
          </div>
        </header>
        <hr />
        <header v-show="!firmware_done" style="display: table-row">
          <div style="display: table-cell; text-align: right">
            Firmware updating :
          </div>
          <div style="display: table-cell; text-align: left">
            {{ !firmware_done }}
          </div>
        </header>
      </section>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { fmtDate } from "../../util/textout.js";

export default {
  name: "UnitDetails",

  props: {
    mac: String,
    name: String,
    purpose: String,
    stable: Boolean,
    seen: Boolean,
    hibernating: Boolean,
    battery: String,
    firmware_done: Boolean,
    schedule_done: Boolean,
    fault_charger: Number,
    fault_valve: Number,
    fault_dry: Number,
    fault_awol: Number,
    latitude: Number,
    longitude: Number,
    radius: Number,
    coverage: Number,
  },

  setup(props) {
    return {
      timestampFmt: computed(() => fmtDate(new Date(props.timestamp))),
    };
  },
};
</script>

<style scoped>
.version-table {
  display: table;
  margin: auto;
  border-spacing: 1rem;
}
</style>
